/**
 * Configuration objects for graph Components to use.
 *
 * Note- We want to export functions here that return config object literals so components can
 * add additional configuration options without mutating a reference object.
 */

/**
 * WARNING-- In general, make specific configuration changes dynamically inside of the graph component
 * consuming this base config, only apply changes here if you are OK with it effecting ALL graphs
 * that use this base configuration. If you find a different configuration set up that is starting
 * to be widely used for a subset of graph types, then export a NEW base config for that set of graphs.
 *
 * @returns {Object} Sensible default config for most Scalyr Graphs
 */
export function getBaseGraphConfig(): Highcharts.Options {
  return {
    chart: {
      alignTicks: false,
      backgroundColor: 'transparent',
      zoomType: 'x',
      style: {
        fontFamily: 'Open Sans',
      },
    },
    // No bottom legend
    legend: {
      enabled: false,
    },
    // No data export menu
    exporting: {
      enabled: false,
    },
    // No 'Highcharts.com' link
    credits: {
      enabled: false,
    },
    // No title
    title: {
      text: '',
      style: {
        display: 'none',
      },
    },
    subtitle: {
      text: '',
      style: {
        display: 'none',
      },
    },
    tooltip: {
      enabled: false,
    },
    xAxis: {
      type: 'datetime',
      // These formats are used for different timespans and specifically address the day boundaries
      dateTimeLabelFormats: {
        millisecond: '%l:%M:%S.%L %p',
        second: '%l:%M:%S %p',
        minute: '%l:%M %p',
        hour: '%l %p',
        day: '%b %e',
        week: '%b %e',
        month: "%b '%y",
        year: '%Y',
      },
    },
    yAxis: {
      title: {
        text: null,
      },
    },
    plotOptions: {
      area: {
        animation: false,
        stacking: 'normal' as Highcharts.OptionsStackingValue,
      },
      areaspline: {
        animation: false,
      },
      column: {
        animation: false,
        stacking: 'normal' as Highcharts.OptionsStackingValue,
        borderWidth: 0,
      },
      line: {
        animation: false,
      },
      pie: {
        animation: false,
      },
      spline: {
        animation: false,
      },
    },
  };
}
